<template>
    <li>
        <span v-show="!isNullOrWhiteSpace(tenant.displayLabel)">{{ tenant.displayLabel }}</span>
        (<strong style="font-weight: 700">{{ tenant.urlSlug }}</strong
        ><span>/{{ tenant.code }}/{{ tenant.type || "Null" }}/{{ tenant.tier || "Null" }})</span>
        <HelpIcon :text="tenant.description" />
        &nbsp;&nbsp;<a :href="indexUrl" v-if="indexUrl">Goto</a> &nbsp;&nbsp;<a @click.prevent="gotoEdit" :href="editUrl">Edit</a>
        <ul v-if="tenant.subtenants.length > 0">
            <IndexTenant v-for="subtenant in sortedSubtenants" :tenant="subtenant" :key="subtenant.code" v-on:change-page="changePage($event as ChangePageEvent)" />
        </ul>
    </li>
</template>
<script lang="ts">
import { defineComponent, computed, SetupContext, inject } from "vue";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import { useMainStore } from "@/mainStore";
import { asyncComputed } from "@vueuse/core";
import { TenantViewModel } from "@cs-ts/tenant-view-model_1";
//eslint-disable-next-line @typescript-eslint/no-unused-vars
import { changePageInjectKey, ChangePageEvent } from "@/AppShell.3.vue.InjectKeys";
type TenantViewModelExtended = Omit<TenantViewModel, "subtenants"> & { subtenants: TenantViewModelExtended[] };
type Props = { tenant: TenantViewModelExtended };

export default defineComponent({
    name: "IndexTenant",
    props: ["tenant"],
    components: {
        HelpIcon,
    },
    setup(props: Props, { emit }: SetupContext) {
        const mainStore = useMainStore();
        const sortedSubtenants = computed(() => {
            return props.tenant.subtenants.slice().sort((a, b) => (a.displayLabel || "").localeCompare(b.displayLabel!));
        });

        const indexUrl = asyncComputed(() => {
            const type = props.tenant.publicAreaEnabled ? "index" : props.tenant.adminAreaEnabled ? "admin" : null;
            if (type != null) {
                return mainStore.getUrl(type, { tenantUrlSlug: props.tenant.urlSlug, tenantCode: props.tenant.code });
            } else {
                return null;
            }
        });
        const editUrl = asyncComputed(() => {
            return mainStore.getUrl("adminTenantManagementEdit", { code: props.tenant.code });
        });

        const isNullOrWhiteSpace = (str: string | undefined | null) => {
            return str == null || /^\s*$/.test(str);
        };
        const gotoEdit = () => {
            emit("change-page", { page: "AdminTenantManagementEdit", settings: { code: props.tenant.code } });
        };

        return {
            sortedSubtenants,
            indexUrl,
            editUrl,

            isNullOrWhiteSpace,
            gotoEdit,

            changePage: inject(changePageInjectKey)!,
        };
    },
});
</script>
